<app-side-top-bar [navigationItems]="navigationItems">
  <main class="main">
    <!-- <mat-icon class="expand-icon">expand_all</mat-icon> -->
    <div class="active-status">
      <h2
        [ngClass]="
          isPatientActive ? 'patient-name' : 'patient-name name-not-active'
        "
      >
        {{ patientNameAndSurname }}
      </h2>
    </div>

    <section class="interview-page">
      <!-- note and reminder section -->
      @if (!isMobilePortrait && isMobile && isNoteAndReminderSection) {
        <span> Gira il telefono per vedere le note e i promemoria </span>
      }
      @if (!isMobile || (isMobilePortrait && isNoteAndReminderSection)) {
        <section class="note-reminder">
          <!-- note section -->
          <section class="note">
            @if (isLoadingNotes) {
              <app-loader
                [size]="'big'"
                style="display: flex; justify-content: center; margin-top: 3rem"
              ></app-loader>
            }
            @if (!isLoadingNotes) {
              <app-patient-notes
                style="height: 100%"
                [patientId]="patientId"
                [isMobile]="isMobile"
                [notes]="notes"
                (switchPanels)="switchSectionMobile()"
                (changesInNotes)="getNotes()"
              ></app-patient-notes>
            }
          </section>
          <!-- reminder section -->
          <section class="reminder">
            @if (isLoadingReminders) {
              <app-loader
                [size]="'big'"
                style="display: flex; justify-content: center; margin-top: 3rem"
              ></app-loader>
            }
            @if (!isLoadingReminders) {
              <app-patient-reminders
                style="height: 100%"
                [patientId]="patientId"
                [isMobile]="isMobile"
                [reminders]="reminders"
                [filteredReminders]="filteredReminders"
                (switchPanels)="switchSectionMobile()"
                (changesInReminders)="getReminders()"
              ></app-patient-reminders>
            }
          </section>
        </section>
      }

      <!-- interviews section -->
      @if (!isMobile || isInterviewSection) {
        <section class="interview">
          <header class="header">
            <div class="sections">
              <div
                class="{{ isPastAppointmentsSelected }}"
                (click)="displayPastAppointmentSection()"
              >
                <h2>{{ labelService.getLabel("Storico Appuntamenti") }}</h2>
              </div>
              <div
                class="{{ isFutureAppointmnetsSelected }}"
                (click)="displayFutureAppointmentSection()"
              >
                <h2>{{ labelService.getLabel("Prossimi Appuntamenti") }}</h2>
              </div>
            </div>
            <div class="header-buttons">
              <app-button
                [icon]="'add'"
                (click)="toggleNewInterviewPanel()"
              ></app-button>
              @if (isMobilePortrait) {
                <app-button
                  [icon]="'swap_horiz'"
                  color="light-green"
                  (click)="switchSectionMobile()"
                ></app-button>
              }
            </div>
          </header>
          <!-- interview table -->
          @if (appointmentsToBeDisplayed.length > 0) {
            <div class="table-container">
              <table
                mat-table
                [dataSource]="appointmentsToBeDisplayed"
                class="appointment-table"
              >
                <!-- Date Column -->
                <ng-container matColumnDef="date">
                  <th mat-header-cell *matHeaderCellDef>Data</th>
                  <td
                    mat-cell
                    *matCellDef="let appointment"
                    class="clickable-cell"
                    (click)="navigateInterviewDetails(appointment)"
                  >
                    {{ appointment.date }} {{ appointment.start_time }}
                  </td>
                </ng-container>
                <!-- Title Column -->
                <ng-container matColumnDef="title">
                  <th mat-header-cell *matHeaderCellDef>Titolo</th>
                  <td
                    mat-cell
                    *matCellDef="let appointment"
                    class="clickable-cell"
                    (click)="navigateInterviewDetails(appointment)"
                  >
                    {{ appointment.title }}
                  </td>
                </ng-container>
                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let appointment">
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="menu"
                      class="action-button"
                    >
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu">
                      <button
                        mat-menu-item
                        (click)="handleMenuAction('edit', appointment)"
                      >
                        <mat-icon>edit</mat-icon>
                        <span>Modifica</span>
                      </button>
                      <button
                        mat-menu-item
                        (click)="handleMenuAction('delete', appointment)"
                      >
                        <mat-icon>delete</mat-icon>
                        <span>Elimina</span>
                      </button>
                    </mat-menu>
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                ></tr>
              </table>
            </div>
          }
          @if (
            appointmentsToBeDisplayed.length === 0 && !isLoadingPastAppointments
          ) {
            <div class="no-appointments">
              <img
                src="assets/imgs/undraw/undraw_empty.svg"
                alt="Nessun Appuntamento"
              />
              <span>Nessun appuntamento da mostrare</span>
            </div>
          }
          @if (isLoadingPastAppointments) {
            <app-loader
              [size]="'big'"
              style="display: flex; justify-content: center; margin-top: 3rem"
            ></app-loader>
          }
        </section>
      }

      @if (showModifyAppointmentPanel) {
        <app-add-new-patient-panel
          [title]="'edit_appointment'"
          [onlyNewAppointment]="true"
          [newAppointmentTitle]="modifyAppointment_title"
          [newAppointmentDay]="modifyAppointment_day"
          [newAppointmentMonth]="modifyAppointment_month"
          [newAppointmentYear]="modifyAppointment_year"
          [newAppointmentHours]="modifyAppointment_hours"
          [newAppointmentMinutes]="modifyAppointment_minutes"
          [newAppointmentLenght]="modifyAppointment_lenght"
          (cancel)="modifyAppointment()"
          (confirm)="confirmModifyAppointment($event)"
        >
        </app-add-new-patient-panel>
      }

      <!-- delete appointment panel
      <app-confirmation-panel
        *ngIf="showDeleteAppointmentPanel"
        [title]="'Vuoi davvero cancellare questo appuntamento?'"
        (cancel)="deleteAppointment()"
        (confirm)="confirmDeleteAppointment()"
      ></app-confirmation-panel> -->

      <!-- new interview panel -->

      @if (showNewInterviewPanel) {
        <app-add-new-patient-panel
          [numberOfAppointments]="pastAppointments.length"
          [patientNameAndSurname]="patientNameAndSurname"
          [title]="'new_interview'"
          [onlyNewAppointment]="true"
          (cancel)="toggleNewInterviewPanel()"
          (confirm)="confirmNewInterview($event)"
        >
        </app-add-new-patient-panel>
      }
    </section>
  </main>
</app-side-top-bar>
